import React, { Component } from 'react';

// Import Images
import bnrImg1 from '../../images/banner/img1.jpg';
import image1 from '../../images/new-tech/image1.webp';
import image2 from '../../images/new-tech/image2.jpg';
import image3 from '../../images/new-tech/image3.jpeg';
import image4 from '../../images/new-tech/image4.jpeg';
import image5 from '../../images/new-tech/image5.jpg';
import image6 from '../../images/new-tech/image6.webp';

class NewTechnology extends Component {
	render() {
		const technologies = [
			{
					image: image1,
				title: 'Digital & Panoramic X-Rays',
				description:
					'Advanced digital and panoramic X-rays help us capture clear diagnostic images with greater precision and significantly lower radiation than traditional methods. This allows for more accurate treatment planning and faster, more comfortable visits.',
			},
			{
					image: image2,
				title: 'Intraoral Camera & Scanner',
				description:
					'Intraoral imaging and digital scanning allow us to view your teeth in detail and build precise digital models without messy impressions. You can also see what we see, making treatment discussions easier and more transparent.',
			},
			{
					image: image3,
				title: '3D Printers',
				description:
					'Our in-office 3D printing technology supports faster turnaround for select appliances and treatment tools. This improves fit, reduces waiting times, and helps deliver a smoother care experience from start to finish.',
			},
			{
					image: image4,
				title: 'Digital Smile Design',
				description:
					'Digital Smile Design lets us plan cosmetic outcomes with precision before treatment begins. With a visual roadmap, we can align your goals with functional needs and create predictable, personalized smile results.',
			},
			{
					image: image5,
				title: 'Rotary Endodontics Handpiece',
				description:
					'Rotary endodontic technology helps make root canal procedures more efficient, precise, and comfortable. Enhanced control and consistency can improve outcomes while reducing chair time for many patients.',
			},
			{
					image: image6,
				title: 'Dental X-Rays, Now In Color',
				description:
					'We also use Overjet, an AI-assisted platform that presents dental X-ray findings in color for clearer patient communication. It helps highlight areas of concern and supports better understanding during treatment planning conversations.',
			},
		];

		return (
			<>
				<div className="page-content bg-white">
					<div className="banner-wraper">
						<div className="page-banner" style={{ backgroundImage: 'url(' + bnrImg1 + ')' }}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Advanced Technology</h1>
								</div>
							</div>
						</div>
					</div>

					<section className="section-sp1">
						<div className="container">
							<div className="heading-bx text-center">
								<h6 className="title-ext text-secondary">Technology At Family Eco Dental</h6>
								<h2 className="title">Cutting-Edge Tools For Better, More Comfortable Care</h2>
								<p>
									Our office combines modern technology with a patient-first approach. These systems
									help us diagnose with greater accuracy, plan treatment confidently, and make each
									visit more efficient and comfortable.
								</p>
							</div>

							{technologies.map((item, index) => {
								const isEven = index % 2 === 0;
								return (
									<div className="row align-items-stretch mb-30" key={item.title}>
										<div className={`col-lg-5 mb-20 mb-lg-0 ${isEven ? '' : 'order-lg-3'}`}>
											<img
												src={item.image}
												alt={item.title}
												style={{
													width: '100%',
													height: '290px',
													objectFit: 'cover',
													border: '1px solid #e6e6e6',
												}}
											/>
										</div>

										<div className="col-lg-2 d-none d-lg-flex justify-content-center">
											<div
												style={{
													width: '2px',
													backgroundColor: '#23a455',
													position: 'relative',
												}}
											>
												<span
													style={{
														position: 'absolute',
														top: '50%',
														left: '50%',
														transform: 'translate(-50%, -50%)',
														width: '38px',
														height: '38px',
														borderRadius: '50%',
														backgroundColor: '#fff',
														border: '2px solid #99b19c',
														color: '#5f7e63',
														display: 'inline-flex',
														alignItems: 'center',
														justifyContent: 'center',
														fontWeight: 700,
													}}
												>
													{index + 1}
												</span>
											</div>
										</div>

										<div className={`col-lg-5 ${isEven ? '' : 'order-lg-1'}`}>
											<div
												style={{
													minHeight: '290px',
													backgroundColor: '#f7f7f7',
													border: '1px solid #ececec',
													padding: '35px 30px',
												}}
											>
												<h4 className="title mb-20">{item.title}</h4>
												<p className="mb-0">{item.description}</p>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</section>
				</div>
			</>
		);
	}
}

export default NewTechnology;
